<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        title
        @back="$router.replace({ name: 'home' })"
        :content="$t('cockpit-faturamento')"
      ></el-page-header>
    </el-card>
    <br />
    <el-card>
      <el-card shadow="hover">
        <el-form :model="ruleForm" :inline="true" :rules="rules" ref="ruleForm">
          <el-form-item :label="$t('periodo')" prop="name">
            <el-date-picker
              v-model="ruleForm.start"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="à"
              format="dd/MM/yyyy"
              start-placeholder="Inicio"
              end-placeholder="Fim"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('cliente')" prop="customer">
            <CustomerList v-model="ruleForm.customer" :multiple="true" />
          </el-form-item>
          <el-button type="info"                 
            size="mini" 
            @click="fetchRecords()">Filtrar</el-button>
          <el-button 
            size="mini" 
            type="default"
            v-if="userType === '1'"
            @click="fetchReport()">Relatório Fatura</el-button>
          <!--el-button type="primary" @click="generate">Gerar Boletos</!--el-button-->
          <el-upload  
            class="right"
            ref="upload"
            v-loading="loading"
            :limit="1"
            :on-exceed="exceedUploadRet"
            :auto-upload="false"
            :on-change="onChangeFile"
            action=""
          >
            <el-button slot="trigger" size="small" type="primary"
              >Selecionar arquivo</el-button
            >
            <el-button
              style="margin-left: 10px"
              size="small"
              type="success"
              @click="submitUpload"
              >Importar</el-button
            >
            <div class="el-upload__tip" slot="tip">
              Importar arquivo de retorno
            </div>
          </el-upload>
        </el-form>
      </el-card>
      <br />
      <el-row :gutter="5">
        <CockpitInvoiceList ref="invoiceList" :range="ruleForm.start" :customer="ruleForm.customer" />
      </el-row>
      <br />
      <el-row :gutter="5">
        <BilletList ref="billetList" :range="ruleForm.start" :customer="ruleForm.customer" />
      </el-row>
    </el-card>
  </div>
</template>
<script>
import { UserService } from "@/services/users/user.services";
import { BilletService } from "@/services/customers/billet.services";
import { InvoiceReturnServices } from "@/services/customers/invoice.return.services";
import { i18n } from "@/plugin/i18n";
import CockpitInvoiceList from "@/xpost/views/dashboard/financial/admin/CockpitInvoiceList";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import ServicesList from "@/xpost/views/register/services/ServicesList";
import InvoiceList from "@/xpost/views/financial/invoice/InvoiceList";
import BilletList from "@/xpost/views/financial/invoice/BilletList";
import moment from "moment";
import "moment/locale/pt-br";

export default {
  name: "CockpitBillingAdmin",
  components: {
    CockpitInvoiceList,
    ServicesList,
    CustomerList,
    InvoiceList,
    BilletList,
  },
  computed: {
    excel() {
      const vm = this;
      return vm.tableData;
    },
  },
  methods: {
    exceedUploadRet() {
      this.$message.error("Apenas 1 arquivo por vez");
    },
    onChangeFile(file) {
      const ext = file.name.split(".").reverse()[0].toLowerCase();
      if (ext !== "ret") {
        return this.$message.error("Apenas arquivos de retorno são permitidos");
      }
      this.request.file = file;
    },
    async submitUpload() {
      const vm = this;
      let formData = new FormData();
      vm.loading = true;
      await formData.append("file", this.request.file.raw);
      InvoiceReturnServices.add(formData)
        .then((response) => {
          vm.$message({
            type: "success",
            message: `Arquivo importado com sucesso!`,
          });
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => {
          vm.loading = false;
        });
    },
    generate: function () {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      BilletService.add(vm.ruleForm.customer)
        .then((response) => {
          vm.$message({
            type: "success",
            message: `Boletos gerados com sucesso!`,
          });
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    fetchReport() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      const s = moment(vm.ruleForm.start[0]);
      const f = moment(vm.ruleForm.start[1]);
      BilletService.report(
        s.format("YYYY-MM-DD"),
        f.format("YYYY-MM-DD"),
      )
        .then((response) => {
          console.log('response', response);
          this.$message({
            type: "warning",
            message: `Seu relatório de postagens está sendo gerado, assim que terminar você receberá uma notificação no canto superior direito!`,
            duration: 5000,
          });
          vm.$bus.$emit("notifications", response.id);
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());

    },
    fetchRecords() {
      const vm = this;
      vm.$refs.invoiceList.fetchRecords();
      vm.$refs.billetList.fetchRecords();

      /*    const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      UserService.list()
        .then((response) => {
          vm.tableData = response.records;
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());*/
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.userType = response.type;
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });

    vm.fetchRecords();
  },
  data() {
    return {
      userType: '3',
      filter: "",
      drawer: false,
      innerDrawer: false,
      loading: false,
      request: {
        file: {},
      },
      rules: {},
      tableData: [],
      tablePost: [],
      ruleForm: {
        start: [new Date().setDate(new Date().getDate() - 30), new Date()],
        customer: "",
        service: ""
      },
    };
  },
};
</script>
<style>
.right {
  float: right;
}
.label {
  font-weight: bold;
}

.el-upload {
  border: none !important;
}
</style>